export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/569373b84d4fa61cda98164451d2ed57.svg";